import { render } from "./TeamsView.vue?vue&type=template&id=7d481067"
import script from "./TeamsView.vue?vue&type=script&lang=js"
export * from "./TeamsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__